import {
    Box,
    Typography,
    Divider,
    IconButton,
    Grid,
} from "@mui/material";
import ConfirmDialog from "src/components/confirm-dialog/ConfirmDialog";
import Image from "src/components/image/Image";
import { DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Iconify from "src/components/iconify/Iconify";
import { useState, useEffect } from "react";
import { fetchImage } from "src/utils/fetchImage";
import { useCart } from "../CartContext";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useNavigate } from "react-router";
import { useSnackbar } from 'src/components/snackbar';
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import arrowDown from "@iconify-icons/mdi/chevron-down";
import arrowUp from "@iconify-icons/mdi/chevron-up";
import CancelReasonDialog from "./CancelReasonModal";



const ReservationModal = ({ detail, width, open, onClose, getReservation }) => {

    const [imageURLs, setImageURLs] = useState([]);
    const { calculateMenuItemTotal } = useCart();
    const { user } = useSelector((state) => state.login);
    const [venueImageURL, setVenueImageURL] = useState("");
    const [openText, setOpenText] = useState(false);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [cancelReasonModal, setCancelReasonModal] = useState(false);



    useEffect(() => {
        const fetchVenueImage = async () => {
            if (detail?.venueId?.photoURL) {
                try {
                    const res = await fetchImage(detail.venueId.photoURL);
                    setVenueImageURL(res);
                } catch (error) {
                    console.error("Error fetching venue image:", error);
                }
            }
        };

        fetchVenueImage();
    }, [detail?.venueId?.photoURL]);

    function extractDate(isoString) {
        return isoString.split("T")[0];
    }

    const resculdeReservation = (detail) => {
        navigate(`/venue/${detail?.venueId?.id}`, {
            state: {
                isReservation: {
                    detail: detail,
                }
            }
        });
    };

    const onSubmit = async (reservationId, reason) => {
        const getToken = localStorage.getItem("access_token");
        setIsLoading(true);
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/reservation/cancel/b2c/${reservationId}`,
                {
                    reasonOfCancel: reason
                },
                {
                    headers: {
                        Authorization: `Bearer ${getToken}`,
                    },
                }
            );
            if (response) {
                enqueueSnackbar("Reservation Cancelled Successfully", { variant: 'success' });
                setIsLoading(false);
                onClose();
                await getReservation()
            }
        }
        catch (error) {
            setIsLoading(false);
            console.error("Error cancelling reservation:", error);
        }
    }

    function formatTimeWithDate(startTime, endTime) {
        const date = new Date(startTime);
        const options = { weekday: 'short', day: '2-digit', month: 'short' };

        function formatTime(time) {
            const dateObj = new Date(time);
            let hours = dateObj.getUTCHours();
            let minutes = dateObj.getUTCMinutes();
            const ampm = hours >= 12 ? 'pm' : 'am';

            hours = hours % 12 || 12;
            minutes = minutes.toString().padStart(2, '0');

            return `${hours}:${minutes} ${ampm}`;
        }

        return `${formatTime(startTime)}`;
    }


    const CustomSvgIcon = ({ name, size = 20 }) => (
        <img
            src={`/assets/icons/reservationHistory/${name}.svg`}
            alt={name}
            style={{ width: size, height: size, marginRight: 8 }}
        />
    );
    const InfoRow = ({ icon, label, value }) => (
        <Box
            display="flex"
            alignItems="center"
            sx={{
                gap: 1.5,
                mb: {
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                }
            }}
        >
            <CustomSvgIcon name={icon} sx={{ minWidth: 24 }} />
            <Typography sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                {label} :
            </Typography>
            <Typography color="text.primary" sx={{ wordBreak: 'break-word' }}>
                {value}
            </Typography>
        </Box>
    );

    return (
        <>
            <ConfirmDialog width="md" open={open} onClose={onClose}>
                <DialogTitle sx={{
                    pb: 0, mb: {
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                    }
                }}>
                    <Box display="flex" justifyContent="space-between">
                        <Box display="flex" gap={2}>
                            <Image
                                src={venueImageURL || "/assets/placeholder.png"}
                                alt="Venue"
                                style={{ height: 80, width: 100, borderRadius: 6 }}
                            />
                            <Box>
                                <Typography variant="h6" fontWeight="bold" color="#F59B34" paddingLeft={"5px"}>
                                    {detail?.venueId?.name}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        marginTop: 1,
                                        gap: 0.2,
                                    }}
                                >
                                    <Iconify
                                        sx={{
                                            color: "#F59B34",
                                            height: 30,
                                            width: 30,
                                            // display: { sm: "block" },
                                            "@media (max-width: 1200px)": {
                                                height: 20,
                                                width: 20,
                                            },
                                            "@media (max-width: 1000px)": {
                                                width: 20,
                                                height: 20,
                                            },
                                        }}
                                        icon={"mdi:location"}
                                    />
                                    <Typography color="textSecondary" fontSize={12}
                                        sx={{
                                            padding: {
                                                xs: "2px 0px 0px 0px",
                                                sm: "2px 0px 0px 0px",
                                                md: "5px 0px 0px 0px",
                                                lg: "5px 0px 0px 0px",
                                            }
                                        }}
                                    >
                                        {`${detail?.venueId?.venueAddressOne} ${detail?.venueId?.venueAddressTwo}`}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <IconButton onClick={onClose} sx={{ margin: "0px 0px 60px 0px" }}>
                            <Iconify icon="mdi:close" color="#fca92e" />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <Divider
                    sx={{
                        margin: {
                            xs: "10px 10px",
                            sm: "10px 20px",
                            md: "10px 20px",
                            lg: "10px 20px",
                        },
                        marginTop: "10px",
                        color: "#0000040",
                        border: "1px solid #D3D3D3",
                    }}
                />

                <DialogContent>
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={6} sx={{
                            fontWeight: "bold"
                        }}>
                            <InfoRow icon="personName" label="Name" value={`${user?.firstName} ${user?.lastName}`} />
                            <InfoRow icon="reservationID" label="Reservation ID" value={detail?._id?.slice(-6)} />
                            <InfoRow icon="numberOfPerson" label="No of Persons" value={detail?.partySize} />
                            <InfoRow icon="time" label="Time" value={formatTimeWithDate(detail?.startTime, detail?.endTime)} />
                            <InfoRow icon="date" label="Date" value={extractDate(detail?.date)} />

                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
                                <Typography fontWeight={600}>Reservation Note:</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {detail?.venueId?.notes}
                                </Typography>
                            </Box>

                            <Box mt={2} mb={2} sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
                                <Typography
                                    fontWeight={600}
                                    onClick={() => setOpenText(!openText)}
                                    sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer", color: openText ? "#F59B34" : "black" }}
                                >
                                    Cancellation Policy
                                    <Icon icon={openText ? arrowUp : arrowDown} />
                                </Typography>
                                {openText && (
                                    <Typography variant="body2" color="text.secondary">
                                        {detail?.venueId?.cancellationPolicy}
                                    </Typography>
                                )}
                            </Box>
                            {!detail?.isCanceled && detail?.status !== 'checkin' && detail?.status !== 'completed' && (
                                <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                                    <Grid item xs={12} sm={12}>
                                        <LoadingButton
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                                bgcolor: "#F59B34",
                                                color: "#000",
                                                borderRadius: "10px",
                                                padding: "10px 16px",
                                                borderRadius: "10px",
                                                "&:hover": { bgcolor: "#B66816" },
                                            }}
                                            onClick={() => resculdeReservation(detail)}
                                        >
                                            Reschedule
                                        </LoadingButton>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <LoadingButton
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                padding: "10px 16px",
                                                color: "black",
                                                border: "1px solid #ccc",
                                                borderRadius: "10px",
                                                "&:hover": { bgcolor: "#F59B34", border: "none" },
                                            }}
                                            onClick={() => setCancelReasonModal(true)}
                                            loading={isLoading}
                                        >
                                            Cancel Reservation
                                        </LoadingButton>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
            </ConfirmDialog>
            <CancelReasonDialog
                open={cancelReasonModal}
                onClose={() => setCancelReasonModal(false)}
                onConfirm={(reason) => {
                    onSubmit(detail.id, reason);
                    setCancelReasonModal(false);
                }}
                loading={isLoading}
            />

        </>
    );
};

export default ReservationModal;
